// import React, { useState, useEffect } from "react";
// import { ButtonGroup } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import styled from "styled-components";
// import { ChartArea, MessageCircle, MessageSquare, Search } from "lucide-react";

// import User from "./../User";
// import Credit from "./../Credit";
// import Logo from "./../Logo";

// import { Menu, X } from "lucide-react";
// import { addNewStyle, CRISTP_ID, wait } from "../../../../Helper";

// const ToggleButton = styled.button`
//   background: none;
//   border: none;
//   color: white;
//   font-size: 24px;
//   cursor: pointer;
//   z-index: 1001;
// `;

// const HeaderContainer = styled.header`
//   background-color: #23262b;
//   height: 80px;
//   display: flex;
//   width: 100%;
//   align-items: center;
//   padding: 0 20px;
//   justify-content: space-between;
//   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
//     0 2px 4px -1px rgba(0, 0, 0, 0.06);
// `;

// const SearchBarContainer = styled.div`
//   display: flex;
//   align-items: center;
//   background-color: #1b1e22;
//   border-radius: 30px;
//   padding: 12px 16px;
//   width: 100%;
//   max-width: 600px;
//   transition: all 0.2s ease-in-out;
//   border: ${(props) =>
//     props.isFocused ? "2px solid #4caf50" : "2px solid transparent"};
//   margin-right: 10px;
// `;

// const SearchInput = styled.input`
//   background-color: transparent;
//   border: none;
//   color: #ffffff;
//   font-size: 14px;
//   width: 100%;
//   margin-left: 8px;
//   outline: none;

//   &::placeholder {
//     color: #a0a0a0;
//   }
// `;

// const LogoContainer = styled.div`
//   margin-right: 10px;
// `;

// const FullLogo = styled.img`
//   height: auto;
//   width: 150px;
// `;

// const ShortLogo = styled.div`
//   font-size: 20px;
//   font-weight: bold;
//   font-style: italic;
// `;
// const RightWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   padding-right: 300px;

//   @media (max-width: 1200px) {
//     padding-right: 150px;
//   }

//   @media (max-width: 992px) {
//     padding-right: 100px;
//   }

//   @media (max-width: 768px) {
//     padding-right: 50px;
//   }

//   @media (max-width: 576px) {
//     padding-right: 20px;
//   }
// `;

// const FlexContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   width: 100%;
// `;

// const StyledImg = styled.img`
//   height: 20px;
//   width: 20px;
//   filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
//     brightness(94%) contrast(87%);
// `;
// const StyledImg2 = styled.img`
//   height: 25px;
//   width: 23px;
//   filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
//     brightness(94%) contrast(87%);
// `;

// const Header = ({ isCollapsedMobile, setIsCollapsedMobile }) => {
//   const [isFocused, setIsFocused] = useState(false);
//   const [showFullLogo, setShowFullLogo] = useState(window.innerWidth > 768);

//   const [loaded, setLoaded] = useState(false);

//   const support = () => {
//     window.$crisp = [];
//     window.CRISP_WEBSITE_ID = CRISTP_ID;

//     if (!loaded) {
//       console.log("support");
//       setLoaded(true);
//       const script = document.createElement("script");
//       script.src = "https://client.crisp.chat/l.js";
//       script.id = "chtt";
//       script.async = true;
//       document.head.appendChild(script);
//     }

//     addNewStyle("#crisp-chatbox {display:block !important;}");
//     addNewStyle(
//       ".crisp-client .cc-kv6t .cc-1xry .cc-ge4v .cc-qqzz .cc-5b24 .cc-19cg {display:none !important;}"
//     );

//     wait(2000).then(() => {
//       const close = document.querySelector(".cc-wdhl");
//       if (close === null) return;
//       close.addEventListener("click", function (event) {
//         addNewStyle("#crisp-chatbox {display:none !important;}");
//         document.getElementById("chtt").src = "";
//       });
//     });
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setShowFullLogo(window.innerWidth > 768);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <HeaderContainer>
//       <FlexContainer>
//         <LogoContainer>
//           <Link to="/">
//             {showFullLogo ? (
//               <FullLogo src="/assets/images/lg.png" alt="Logo" />
//             ) : (
//               <ShortLogo>
//                 <span style={{ color: "#CD7F28" }}>F</span>
//                 <span style={{ color: "#00BF63" }}>P</span>
//               </ShortLogo>
//             )}
//           </Link>
//         </LogoContainer>

//         {!showFullLogo && (
//           <ToggleButton
//             onClick={() => setIsCollapsedMobile(!isCollapsedMobile)}
//           >
//             {isCollapsedMobile ? (
//               <X size={24} style={{ position: "absolute", left: "191px" }} />
//             ) : (
//               <Menu size={24} />
//             )}
//           </ToggleButton>
//         )}
//       </FlexContainer>

//       {showFullLogo && (
//         <SearchBarContainer isFocused={isFocused}>
//           <Search size={18} color="#a0a0a0" />
//           <SearchInput
//             placeholder="Game name | Provider | Category Tag"
//             onFocus={() => setIsFocused(true)}
//             onBlur={() => setIsFocused(false)}
//           />
//         </SearchBarContainer>
//       )}

//       <RightWrapper>
//         <Credit />
//         <ButtonGroup>
//           <User />
//         </ButtonGroup>
//         {/* <MessageSquare size={20}/ */}
//         <StyledImg src="/assets/images/nanoicons/notification.png" />
//         <StyledImg2
//           style={{ cursor: "pointer" }}
//           onClick={support}
//           src="/assets/images/nanoicons/nanochat.png"
//         />
//       </RightWrapper>
//     </HeaderContainer>
//   );
// };

// export default Header;

// import React, { useState, useEffect } from "react";
// import { ButtonGroup } from "react-bootstrap";
// import { Link } from "react-router-dom";
// import styled from "styled-components";
// import Modal from "react-modal";
// import { MdLock } from "react-icons/md";
// import { ChartArea, MessageCircle, MessageSquare, Search } from "lucide-react";
// // import SpinImage from "/assets/images/subHeader/promotion-spin.99a0cd5f.png"

// import User from "./../User";
// import Credit from "./../Credit";
// import Logo from "./../Logo";

// import { Menu, X } from "lucide-react";
// import { addNewStyle, CRISTP_ID, wait } from "../../../../Helper";
// import { style } from "@mui/system";

// const ToggleButton = styled.button`
//   background: none;
//   border: none;
//   color: white;
//   font-size: 24px;
//   cursor: pointer;
//   z-index: 1001;
// `;

// const HeaderContainer = styled.header`
//   background-color: #292D2E;
//   height: 60px;
//   display: flex;
//   width: 100%;
//   align-items: center;
//   padding: 0 20px;
//   justify-content: space-between;
//   box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
//     0 2px 4px -1px rgba(0, 0, 0, 0.06);

//     @media(max-width:425px){
//       padding: 0 5px;
//     }
// `;

// const SubHeaderContainer = styled.div`
//   background-color: #000;
//   // display: flex;
//   // justify-content: center;
//   padding: 10px 20px;
//   width: 100%;
//   position: absolute;
//   top: 80px;
//   left: 0;
//   z-index: -1000;

//   @media (min-width: 576px) {
//     display: none;
//   }

//     @media (max-width: 300px) {
//   padding: 5px 0px;
//   }
// `;

// const SubHeaderItem = styled.div`
//   margin: 0 10px;
//   color: #ffffff;
//   font-size: 14px;
//   cursor: pointer;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
// `;
// const SubHeaderIcon = styled.div`
//   display: flex;
//   gap: 10px;
// `;
// const Subicon = styled.div`
//   background-color: #0c0d0f;
//   position:relative;
//   cursor: pointer;
//   width: 2.75rem; /* 11 * 0.25rem */
//   height: 2.5rem; /* 10 * 0.25rem */
//   text-align: center;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   border-radius: 0.75rem;
//   @keyframes spin {
//     0% {
//       transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(360deg);
//     }
//   }

//   @media(max-width:375px){
//   width:2rem;
//   height:2rem;
//    border-radius: 0.55rem;
//   }
// `;

// const SearchBarContainer = styled.div`
//   display: flex;
//   align-items: center;
//   background-color: rgb(58 65 66);
//   border-radius: 10px;
//   padding: 6px 6px;
//   width: 100%;
//   max-width: 40px;
//   transition: all 0.2s ease-in-out;
//   border: ${(props) =>
//     props.isFocused ? "2px solid #4caf50" : "2px solid transparent"};
//   margin-right: 10px;

//   @media(max-width:992px){
//   display:none;
//   }
// `;

// const SearchInput = styled.input`
//   background-color: transparent;
//   border: none;
//   color: #ffffff;
//   font-size: 14px;
//   width: 100%;
//   margin-left: 8px;
//   outline: none;

//   &::placeholder {
//     color: #a0a0a0;
//   }
// `;

// const LogoContainer = styled.div`
//   margin-right: 10px;

//   @media(max-width:335px){
//    margin-right: 0px;
//   }
// `;

// const FullLogo = styled.img`
//   height: auto;
//   width: 150px;
// `;

// const ShortLogo = styled.div`
//   font-size: 20px;
//   font-weight: bold;
//   font-style: italic;
// `;

// const SubIconImage = styled.img`
//   animation: spin 1s linear infinite;
//   margin-top: -2px;
//   width: 2.75rem;
//   height: 2.75rem;

//   @media(max-width:375px){
//   width: 2.0rem;
//   height: 2.0rem;
//   }
// `;

// const SubIconImage1 = styled.img`
//   margin-top: -2px;
//   width: 2.75rem; /* 11 * 0.25rem (size-11) */
//   height: 2.75rem;

//   @media(max-width:375px){
//   width: 2.0rem;
//   height: 2.0rem;
//   }

// `;

// const SubIconImage2 = styled.img`
//   width:2.10rem;
//    height: 2.10rem;

//     @media(max-width:375px){
//   width: 1.75rem;
//   height: 1.75rem;
//   }
// `;

// const LocationImage = styled.img`
// position:absolute;
// width:46px;
// height:46px;
// transform: scaleX(-1);
//     margin-left: 0px;
//     transform-origin: center center;
//     z-index:22;
// `;

// const StyledImage1 =styled.img`
//  width: 1.3rem;
//   height: 1.3rem;
//   margin-right:10px;
// opacity:0.5;

// @media(max-width:375px){
//  margin-right:4px;
// }
// `

// const LockImage =styled.div`
// position:absolute;
// width:19px;
// height:19px;
// z-index: 1;
// background-color: #454850;
// border-radius: 0.5625rem;
// right: -0.3125rem;
//  top: -0.3125rem;

//  @media(max-width:375px){
//  width:16px;
// height:16px;
//  }
// `;

// const StyledImage2 = styled.img`
//   // margin-top: -2px;
//   width: 1.5rem; /* 11 * 0.25rem (size-11) */
//   height: 1.5rem;
//   opacity:0.5;
// `;

// const RightWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 10px;
//   padding-right: 260px;

//   @media (max-width: 1200px) {
//     padding-right: 240px;
//   }

//   @media (max-width: 992px) {
//     // padding-right: 100px;
//   }

//   @media (max-width: 768px) {
//     padding-right: 0px;
//   }

//   @media (max-width: 576px) {
//     padding-right: 0px;
//   }

//   @media (max-width: 416px) {
//     padding-right: 0px;
//   gap: 5px;
//   }
// `;

// const FlexContainer = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 6px;
//   width: 100%;

//   @media(max-width:425px){
//   gap: 0px;
//   }
// `;

// const StyledImg = styled.img`
//   height: 25px;
//   width: 25px;
//   filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
//     brightness(94%) contrast(87%);

//   @media (max-width: 575px) {
//     display: none;
//   }
// `;

// const StyledImg2 = styled.img`
//   height: 25px;
//   width: 25px;
//   filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
//     brightness(94%) contrast(87%);

//   @media (max-width: 575px) {
//     display: none;
//   }
// `;

// const Subheaderothers = styled.div``;

// const Header = ({ isCollapsedMobile, setIsCollapsedMobile }) => {
//   const [isFocused, setIsFocused] = useState(false);
//   const [showFullLogo, setShowFullLogo] = useState(window.innerWidth > 768);
//   const [loaded, setLoaded] = useState(false);
//   const [showSubHeader, setShowSubHeader] = useState(window.innerWidth <= 576);
//   const [isChatModalOpen, setIsChatModalOpen] = useState(false);

//   const support = () => {
//     window.$crisp = [];
//     window.CRISP_WEBSITE_ID = CRISTP_ID;

//     if (!loaded) {
//       console.log("support");
//       setLoaded(true);
//       const script = document.createElement("script");
//       script.src = "https://client.crisp.chat/l.js";
//       script.id = "chtt";
//       script.async = true;
//       document.head.appendChild(script);
//     }

//     addNewStyle("#crisp-chatbox {display:block !important;}");
//     addNewStyle(
//       ".crisp-client .cc-kv6t .cc-1xry .cc-ge4v .cc-qqzz .cc-5b24 .cc-19cg {display:none !important;}"
//     );

//     wait(2000).then(() => {
//       const close = document.querySelector(".cc-wdhl");
//       if (close === null) return;
//       close.addEventListener("click", function (event) {
//         addNewStyle("#crisp-chatbox {display:none !important;}");
//         document.getElementById("chtt").src = "";
//       });
//     });
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       setShowFullLogo(window.innerWidth > 768);
//       setShowSubHeader(window.innerWidth <= 576);
//     };

//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const openChatModal = () => {
//     setIsChatModalOpen(true);
//   };

//   const closeChatModal = () => {
//     setIsChatModalOpen(false);
//   };

//   return (
//     <>
//       <HeaderContainer>
//         <FlexContainer>
//           {/* <LogoContainer>
//             <Link to="/">
//               {showFullLogo ? (
//                 <FullLogo src={process.env.REACT_APP_LG_LOGO} alt="Logo" />
//               ) : (
//                 <ShortLogo>
//                   <span style={{ color: "#CD7F28" }}>F</span>
//                   <span style={{ color: "#00BF63" }}>P</span>
//                 </ShortLogo>
//               )}
//             </Link>
//           </LogoContainer> */}

//           {!showFullLogo && (
//             <ToggleButton
//               onClick={() => setIsCollapsedMobile(!isCollapsedMobile)}
//             >
//               {isCollapsedMobile ? (
//                 <X size={24} style={{ position: "absolute", left: "191px" }} />
//               ) : (
//                 <Menu size={24} className="menu-icon-new"/>
//               )}
//             </ToggleButton>
//           )}
//         </FlexContainer>

//         {showFullLogo && (
//           <SearchBarContainer isFocused={isFocused}>
//              <img src="\assets\bcimages\bcheader\search-icon.svg"/>
//             {/* <SearchInput
//               placeholder="Game name | Provider | Category Tag"
//               onFocus={() => setIsFocused(true)}
//               onBlur={() => setIsFocused(false)}
//             /> */}
//           </SearchBarContainer>
//         )}

//         <RightWrapper>
//           <Credit />

//           <div className="header-gift">
//             <img src="\assets\bcimages\bcheader\gift_icon.svg"/>
//             <div className="gift-top">1</div>
//           </div>
//           <div className="header-icons-bcgame">
//           <StyledImg2
//           style={{ cursor: "pointer" }}
//           onClick={openChatModal}
//           src="\assets\bcimages\bcheader\chat_icon.svg"
//         />
//           <StyledImg src="\assets\bcimages\bcheader\notification_icon.svg" />
//           <div className="mesaasge-top">1</div>
//           </div>
//           <ButtonGroup>
//             <User />
//           </ButtonGroup>
//         </RightWrapper>
//       </HeaderContainer>

//       {showSubHeader && (
//         <SubHeaderContainer>
//           <SubHeaderItem>
//             {/* <StyledImg src="/assets/images/nanoicons/notification.png" /> */}
//             <SubHeaderIcon>
//               <Subicon>
//                 <LocationImage src="/assets/images/pointer.webp"/>
//                 <SubIconImage src="/assets/images/subHeader/promotion-spin.99a0cd5f.png" />
//               </Subicon>
//               <Subicon style={{ opacity: 0.5 }}>
//                 <LockImage>
//                 <MdLock  style={{width:"12px",height:"12px",marginBottom:"7px",opacity:"0.7"}}/>
//                 </LockImage>
//                 <SubIconImage1 src="/assets/images/subHeader/piggy.png" />
//               </Subicon>

//               <Subicon style={{ opacity: 0.5 }}>
//               <LockImage>
//                 <MdLock  style={{width:"12px",height:"12px",marginBottom:"7px",opacity:"0.7"}}/>
//                 </LockImage>
//                 <SubIconImage1 src="/assets/images/subHeader/Recharge.png" />
//               </Subicon>
//               <Subicon>
//                 <SubIconImage2 src="/assets/images/subHeader/shitcode.dcc7e39e.svg"
//                 />
//               </Subicon>
//             </SubHeaderIcon>

//             <Subheaderothers>
//             <StyledImage1 src="/assets/images/nanoicons/notification.png" />
//               <StyledImage2
//                 style={{ cursor: "pointer" }}
//                 onClick={support}
//                 src="/assets/images/nanoicons/nanochat.png"
//               />
//             </Subheaderothers>
//           </SubHeaderItem>
//         </SubHeaderContainer>
//       )}
//     </>
//   );
// };

// export default Header;

import React, { useState, useEffect } from "react";
import { ButtonGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Modal from "react-modal";
import { MdLock } from "react-icons/md";
import { ChartArea, Download, MessageCircle, MessageSquare, Search } from "lucide-react";
// import SpinImage from "/assets/images/subHeader/promotion-spin.99a0cd5f.png"

import User from "./../User";
import Credit from "./../Credit";
import Logo from "./../Logo";

import { Menu, X } from "lucide-react";
import { addNewStyle, CRISTP_ID, wait } from "../../../../Helper";
import { style } from "@mui/system";
import { AiOutlineHome } from "react-icons/ai";
import { PiGiftLight } from "react-icons/pi";
import { IoWalletOutline } from "react-icons/io5";
import { BiSupport } from "react-icons/bi";
import { CgProfile } from "react-icons/cg";
import { RxCross2 } from "react-icons/rx";
import ExploreModal from "./ExploreModal";
import Chat from "../Chat";
import { useTranslation } from "react-i18next";
import DepositUpi from "../../Payment/DepositUpi";
import MobileAppDownloadBanner from "../../../Components/MobileAppDownloadBanner";
const REACT_APP_LG_LOGO = process.env.REACT_APP_LG_LOGO


const ToggleButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;

  @media (max-width: 576px) {
    display: none;
  }
`;

const HeaderContainer = styled.header`
  background-color: rgb(41, 45, 46) !important;
  height: 60px;
  display: flex;
  width: 100%;
  align-items: center;
  padding: 0 20px;
  justify-content: end;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);

  @media (max-width: 450px) {
    padding: 0 10px;
  }

  @media (max-width: 250px) {
    padding: 0 5px;
  }
`;

const RightWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  // padding-right:240px;

  @media (max-width: 381px) {
    gap: 5px;
  }
`;

const SubHeaderContainer = styled.div`
  background-color: #1e2024;
  display: none;
  // justify-content: center;
  padding: 10px 20px;
  width: 100%;
  position: absolute;
  // top: 80px;
  left: 0;
  z-index: -1000;

  @media (min-width: 577px) {
    display: none;
  }

  @media (max-width: 350px) {
    padding: 10px 0px;
  }
`;

const SubHeaderItem = styled.div`
  margin: 0 10px;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const SubHeaderIcon = styled.div`
  display: flex;
  gap: 10px;
`;
const Subicon = styled.div`
  background-color: #0c0d0f;
  position: relative;
  cursor: pointer;
  width: 2.75rem; /* 11 * 0.25rem */
  height: 2.5rem; /* 10 * 0.25rem */
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.75rem;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  @media (max-width: 375px) {
    width: 2rem;
    height: 2rem;
    border-radius: 0.55rem;
  }
`;

const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(58 65 66);
  border-radius: 10px;
  padding: 6px 6px;
  width: 100%;
  max-width: 40px;
  transition: all 0.2s ease-in-out;
  border: ${(props) =>
    props.isFocused ? "2px solid #4caf50" : "2px solid transparent"};
  margin-right: 10px;
  cursor: pointer;
`;

const SearchBarContainerNew = styled.div`
  display: flex;
  align-items: center;
  background-color: rgb(58 65 66);
  border-radius: 10px;
  padding: 6px 6px;
  width: 100%;
  transition: all 0.2s ease-in-out;
  border: ${(props) =>
    props.isFocused ? "2px solid #4caf50" : "2px solid transparent"};
  margin-right: 10px;

  @media (max-width: 350px) {
    max-width: 30px;
    height: 30px;
  }
`;

const SearchInput = styled.input`
  background-color: transparent;
  border: none;
  color: #ffffff;
  font-size: 14px;
  width: 100%;
  margin-left: 8px;
  outline: none;

  &::placeholder {
    color: #a0a0a0;
  }
`;

const LogoContainer = styled.div`
  @media (max-width: 335px) {
    margin-right: 0px;
  }
`;

const FullLogo = styled.img`
  height: auto;
  width: 150px;
`;

const ShortLogo = styled.div`
  font-size: 20px;
  font-weight: bold;
  font-style: italic;
`;

const SubIconImage = styled.img`
  animation: spin 1s linear infinite;
  margin-top: -2px;
  width: 2.75rem;
  height: 2.75rem;

  @media (max-width: 375px) {
    width: 2rem;
    height: 2rem;
  }
`;

const SubIconImage1 = styled.img`
  margin-top: -2px;
  width: 2.75rem; /* 11 * 0.25rem (size-11) */
  height: 2.75rem;

  @media (max-width: 375px) {
    width: 2rem;
    height: 2rem;
  }
`;

const SubIconImage2 = styled.img`
  width: 2.1rem;
  height: 2.1rem;

  @media (max-width: 375px) {
    width: 1.75rem;
    height: 1.75rem;
  }
`;

const LocationImage = styled.img`
  position: absolute;
  width: 46px;
  height: 46px;
  transform: scaleX(-1);
  margin-left: 0px;
  transform-origin: center center;
  z-index: 22;
`;

const StyledImage1 = styled.img`
  width: 1.3rem;
  height: 1.3rem;
  margin-right: 10px;
  opacity: 0.5;

  @media (max-width: 375px) {
    margin-right: 4px;
  }
`;

const LockImage = styled.div`
  position: absolute;
  width: 19px;
  height: 19px;
  z-index: 1;
  background-color: #454850;
  border-radius: 0.5625rem;
  right: -0.3125rem;
  top: -0.3125rem;

  @media (max-width: 375px) {
    width: 16px;
    height: 16px;
  }
`;

const StyledImage2 = styled.img`
  // margin-top: -2px;
  width: 1.5rem; /* 11 * 0.25rem (size-11) */
  height: 1.5rem;
  opacity: 0.5;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;

  @media (max-width: 425px) {
    gap: 0px;
  }
`;

const StyledImg = styled.img`
  height: 25px;
  width: 25px;
  filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
    brightness(94%) contrast(87%);
`;

const StyledImg2 = styled.img`
  height: 25px;
  width: 25px;
  filter: invert(48%) sepia(6%) saturate(426%) hue-rotate(167deg)
    brightness(94%) contrast(87%);
`;

const ShortLogoImg = styled.img`
  height: 50px;
  width: 60px;

  @media (max-width: 350px) {
    height: 20px;
    width: 20px;
  }
`;

const Subheaderothers = styled.div``;

const Header = ({ isCollapsedMobile, setIsCollapsedMobile }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showFullLogo, setShowFullLogo] = useState(window.innerWidth > 768);
  const [loaded, setLoaded] = useState(false);
  const [showSubHeader, setShowSubHeader] = useState(window.innerWidth <= 576);
  const [isChatModalOpen, setIsChatModalOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalOpen1, setModalOpen1] = useState(false);

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const toggleModal1 = () => {
    setModalOpen1(!isModalOpen1);
  };

  const { t } = useTranslation();

  const handleTabClick = (e) => {
    const tabs = document.querySelectorAll(".snapbet-bottom-bar-main li a");
    tabs.forEach((tab) => tab.classList.remove("active"));
    e.currentTarget.classList.add("active");
  };

  const support = () => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = CRISTP_ID;

    if (!loaded) {
      console.log("support");
      setLoaded(true);
      const script = document.createElement("script");
      script.src = "https://client.crisp.chat/l.js";
      script.id = "chtt";
      script.async = true;
      document.head.appendChild(script);
    }

    addNewStyle("#crisp-chatbox {display:block !important;}");
    addNewStyle(
      ".crisp-client .cc-kv6t .cc-1xry .cc-ge4v .cc-qqzz .cc-5b24 .cc-19cg {display:none !important;}"
    );

    wait(2000).then(() => {
      const close = document.querySelector(".cc-wdhl");
      if (close === null) return;
      close.addEventListener("click", function (event) {
        addNewStyle("#crisp-chatbox {display:none !important;}");
        document.getElementById("chtt").src = "";
      });
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setShowFullLogo(window.innerWidth > 768);
      setShowSubHeader(window.innerWidth <= 576);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const openChatModal = () => {
    // setIsChatModalOpen(true);
  };

  const closeChatModal = () => {
    // setIsChatModalOpen(false);
  };

  return (
    <>
      <HeaderContainer>
        <FlexContainer>
          {!showFullLogo && (
            <ToggleButton
              onClick={() => setIsCollapsedMobile(!isCollapsedMobile)}
            >
              {isCollapsedMobile ? (
                <X size={24} style={{ position: "absolute", left: "191px" }} />
              ) : (
                <Menu size={24} className="menu-icon-new" />
              )}
            </ToggleButton>
          )}
          <LogoContainer>
            <Link to="/">
              {showFullLogo ? (
                <FullLogo src={REACT_APP_LG_LOGO} alt="Logo" />
              ) : (
                <ShortLogo>
                  <ShortLogoImg src={process.env.REACT_APP_SM_LOGO} />
                </ShortLogo>
              )}
            </Link>
          </LogoContainer>
        </FlexContainer>

        <RightWrapper>
          {showFullLogo && (
            
            <SearchBarContainer onClick={toggleModal1} isFocused={isFocused}>
              <img src="\assets\bcimages\bcheader\search-icon.svg" />
              {/* <SearchInput
              placeholder="Game name | Provider | Category Tag"
              onFocus={() => setIsFocused(true)}
              onBlur={() => setIsFocused(false)}
            /> */}
            </SearchBarContainer>
          )}
          {/* <a href="/trubetx.apk" download target="_blank" rel="noopener noreferrer">
            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <Download size={20} />
            </div>
          </a> */}
          <Credit />
          {/* <DepositUpi /> */}
          <Link to="/bonus">
            <div className="header-gift">
              <img src="\assets\bcimages\bcheader\gift_icon.svg" />
              {/* <div className="gift-top">1</div> */}
            </div>
          </Link>
          
          <ButtonGroup>
            <User />
          </ButtonGroup>
        </RightWrapper>
      </HeaderContainer>

       <MobileAppDownloadBanner/>

      {showSubHeader && (
        <SubHeaderContainer>
          <SubHeaderItem>
            {/* <StyledImg src="/assets/images/nanoicons/notification.png" /> */}
            <div style={{ display: "flex" }}>
              <SearchBarContainerNew isFocused={isFocused}>
                <img
                  className="search_Icon_header"
                  src="\assets\bcimages\bcheader\search-icon.svg"
                />
                <SearchInput
                  placeholder="Game name | Provider | Category Tag"
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => setIsFocused(false)}
                />
              </SearchBarContainerNew>
              <div className="header-gift2">
                <img src="\assets\bcimages\bcheader\gift_icon.svg" />
                {/* <div className="gift-top">1</div> */}
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="header-icons-bcgame2">
                <Link to="/chat">
                  <StyledImg2
                    style={{ cursor: "pointer" }}
                    onClick={openChatModal}
                    src="\assets\bcimages\bcheader\chat_icon.svg"
                  />
                </Link>
                <StyledImg src="\assets\bcimages\bcheader\notification_icon.svg" />
                <div className="mesaasge-top">1</div>
              </div>
            </div>
          </SubHeaderItem>
        </SubHeaderContainer>
      )}

    
      <div className="snapbet-bottom-bar">
        <ul className="snapbet-bottom-bar-main">
          <li onClick={() => setIsCollapsedMobile(!isCollapsedMobile)}>
            <a className="active" onClick={handleTabClick}>
              <img
                className="icon-home"
                src="\assets\bcimages\sidebar\bcmenu.svg"
              />
              <p>Menu</p>
            </a>
          </li>
          <Link to="/affiliate">
          <li>
            <a onClick={handleTabClick}>
              <img
                className="icon-home"
                src="/assets/bcimages/sidebar/affiliate.svg"
              />
              <p>Affiliate</p>
            </a>
          </li>
          </Link>

          <Link to="/casino">
            <li>
              <a onClick={handleTabClick}>
                <img
                  className="icon-home"
                  src="/assets/bcimages/bchome/casino-home-gamecard.svg"
                />
                <p>Casino</p>
              </a>
            </li>
          </Link>
          <Link to="/vip-club">
            <li>
              <a onClick={handleTabClick}>
                <img
                  className="icon-home"
                  src="/assets/bcimages/sidebar/vip.svg"
                />
                <p>VIP</p>
              </a>
            </li>
          </Link>
          {/* <li onClick={toggleModal}>
            <a onClick={handleTabClick}>
              <img
                className="icon-home"
                src="\assets\bcimages\bcheader\chat_icon.svg"
              />
              <p>Chat</p>
            </a>
          </li> */}
        </ul>
      </div>

      {/* Modal Components */}
      <Modal
        isOpen={isModalOpen1}
        onRequestClose={toggleModal1}
        contentLabel="Referral Terms & Conditions"
        className="explore-modal"
        overlayClassName="custom-overlay"
      >
        <h2>Explore</h2>
        <button onClick={toggleModal1} className="close-modal-button">
          <RxCross2 />
        </button>
        <div
          style={{
            overflowY: "scroll",
            height: "85vh",
            width: "100%",
            zIndex: "99999",
          }}
        >
          <ExploreModal />
        </div>
      </Modal>

      {/* Modal Components */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        contentLabel="Chat"
        className="custom-modal"
        overlayClassName="custom-overlay"
        style={{
          content: {
            padding: 0,
            backgroundColor: "#000",
            width: "100%",
            margin: "auto",
            borderRadius: "10px",
          },
          overlay: { backgroundColor: "rgba(0, 0, 0, 0.8)" },
        }}
      >
        {/* <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px" }}>
          <h2 style={{ color: "white", margin: 0 }}>Chat</h2>
          <RxCross2 size={20} style={{ color: "white", cursor: "pointer" }} onClick={toggleModal} />
        </div> */}
        <div style={{ height: "calc(100% - 50px)" }}>
          <Chat t={t} toggleModal={toggleModal} />
        </div>
      </Modal>
    </>
  );
};

export default Header;
